// Generated by tools/sync_feedback_localizations.py. Do not edit by hand.
export type FeedbackKey =
  "feedback.title" |
  "feedback.introduction" |
  "feedback.category.section" |
  "feedback.category.label" |
  "feedback.category.experience" |
  "feedback.category.bug" |
  "feedback.category.performance" |
  "feedback.category.content" |
  "feedback.category.account" |
  "feedback.category.billing" |
  "feedback.category.other" |
  "feedback.details.section" |
  "feedback.details.placeholder" |
  "feedback.characterCount" |
  "feedback.diagnostics.toggle" |
  "feedback.diagnostics.description" |
  "feedback.followUp.toggle" |
  "feedback.followUp.email" |
  "feedback.submit" |
  "feedback.result.submitted" |
  "feedback.result.queued" |
  "feedback.close" |
  "feedback.settings.section" |
  "feedback.settings.open" |
  "feedback.settings.quickEntry" |
  "feedback.settings.quickEntry.description" |
  "feedback.settings.analytics" |
  "feedback.settings.analytics.description";

export type FeedbackCopy = Record<FeedbackKey, string>;
export type FeedbackLocale =
  "en" |
  "zh-Hans" |
  "zh-Hant" |
  "de" |
  "es-419" |
  "fr" |
  "it" |
  "pt-BR" |
  "ru" |
  "ja" |
  "ko" |
  "ar" |
  "fa" |
  "ur" |
  "hi" |
  "bn" |
  "mr" |
  "gu" |
  "ta" |
  "te" |
  "th" |
  "tr" |
  "vi" |
  "id" |
  "fil" |
  "sw" |
  "ha" |
  "am";

export const feedbackCopy: Record<FeedbackLocale, FeedbackCopy> = {
  "en": {
    "feedback.title": "Feedback",
    "feedback.introduction": "Did you run into an experience problem? Tell us here. If the network is unavailable, your report is saved on this device and sent automatically later.",
    "feedback.category.section": "What happened?",
    "feedback.category.label": "Type",
    "feedback.category.experience": "Experience suggestion",
    "feedback.category.bug": "Something is broken",
    "feedback.category.performance": "Speed or stability",
    "feedback.category.content": "Content",
    "feedback.category.account": "Account",
    "feedback.category.billing": "Billing",
    "feedback.category.other": "Other",
    "feedback.details.section": "Details",
    "feedback.details.placeholder": "Describe what you expected and what happened",
    "feedback.characterCount": "Characters",
    "feedback.diagnostics.toggle": "Include diagnostics",
    "feedback.diagnostics.description": "Includes app version, device model, OS, language and current page. It never includes passwords, tokens, invite secrets or message content.",
    "feedback.followUp.toggle": "Allow follow-up",
    "feedback.followUp.email": "Contact email (optional)",
    "feedback.submit": "Send feedback",
    "feedback.result.submitted": "Thanks. Your feedback has been sent.",
    "feedback.result.queued": "Saved on this device and will send automatically when the network is available.",
    "feedback.close": "Close",
    "feedback.settings.section": "Feedback & Privacy",
    "feedback.settings.open": "Send Feedback",
    "feedback.settings.quickEntry": "Shake to Give Feedback",
    "feedback.settings.quickEntry.description": "Shake the device to open feedback quickly.",
    "feedback.settings.analytics": "Analytics & Improvements",
    "feedback.settings.analytics.description": "Share first-party usage and diagnostic data to improve Artist.",
  },
  "zh-Hans": {
    "feedback.title": "体验反馈",
    "feedback.introduction": "是否遇到了体验问题？请在这里告诉我们。网络不可用时，反馈会保存在本机并在恢复后自动发送。",
    "feedback.category.section": "发生了什么？",
    "feedback.category.label": "类型",
    "feedback.category.experience": "体验建议",
    "feedback.category.bug": "功能异常",
    "feedback.category.performance": "速度与稳定性",
    "feedback.category.content": "内容",
    "feedback.category.account": "账户",
    "feedback.category.billing": "付费与积分",
    "feedback.category.other": "其他",
    "feedback.details.section": "详细说明",
    "feedback.details.placeholder": "请描述你的预期和实际发生的情况",
    "feedback.characterCount": "字数",
    "feedback.diagnostics.toggle": "附带诊断信息",
    "feedback.diagnostics.description": "包含 App 版本、设备型号、系统、语言与当前页面；绝不包含密码、令牌、邀请密钥或消息内容。",
    "feedback.followUp.toggle": "允许后续联系",
    "feedback.followUp.email": "联系邮箱（可选）",
    "feedback.submit": "发送反馈",
    "feedback.result.submitted": "谢谢，你的反馈已发送。",
    "feedback.result.queued": "已保存在本机，网络恢复后会自动发送。",
    "feedback.close": "关闭",
    "feedback.settings.section": "反馈与隐私",
    "feedback.settings.open": "发送反馈",
    "feedback.settings.quickEntry": "摇动设备快速反馈",
    "feedback.settings.quickEntry.description": "摇动设备即可快速打开反馈界面。",
    "feedback.settings.analytics": "分析与产品改进",
    "feedback.settings.analytics.description": "共享第一方使用与诊断数据，帮助改进 Artist。",
  },
  "zh-Hant": {
    "feedback.title": "體驗回饋",
    "feedback.introduction": "是否遇到了體驗問題？請在這裡告訴我們。網路無法使用時，回饋會儲存在本機並於恢復後自動傳送。",
    "feedback.category.section": "發生了什麼？",
    "feedback.category.label": "類型",
    "feedback.category.experience": "體驗建議",
    "feedback.category.bug": "功能異常",
    "feedback.category.performance": "速度或穩定性",
    "feedback.category.content": "內容",
    "feedback.category.account": "帳戶",
    "feedback.category.billing": "付費與點數",
    "feedback.category.other": "其他",
    "feedback.details.section": "詳細說明",
    "feedback.details.placeholder": "請描述你的預期與實際發生的情況",
    "feedback.characterCount": "字數",
    "feedback.diagnostics.toggle": "附帶診斷資訊",
    "feedback.diagnostics.description": "包含 App 版本、裝置型號、系統、語言與目前頁面；絕不包含密碼、權杖、邀請密鑰或訊息內容。",
    "feedback.followUp.toggle": "允許後續聯絡",
    "feedback.followUp.email": "聯絡信箱（選填）",
    "feedback.submit": "傳送回饋",
    "feedback.result.submitted": "謝謝，你的回饋已傳送。",
    "feedback.result.queued": "已儲存在本機，網路恢復後會自動傳送。",
    "feedback.close": "關閉",
    "feedback.settings.section": "回饋與隱私",
    "feedback.settings.open": "傳送回饋",
    "feedback.settings.quickEntry": "搖動裝置快速回饋",
    "feedback.settings.quickEntry.description": "搖動裝置即可快速開啟回饋介面。",
    "feedback.settings.analytics": "分析與產品改進",
    "feedback.settings.analytics.description": "分享第一方使用與診斷資料，協助改進 Artist。",
  },
  "de": {
    "feedback.title": "Feedback",
    "feedback.introduction": "Gab es ein Problem bei der Nutzung? Teile es uns hier mit. Ohne Netzwerk wird dein Bericht auf diesem Gerät gespeichert und später automatisch gesendet.",
    "feedback.category.section": "Was ist passiert?",
    "feedback.category.label": "Typ",
    "feedback.category.experience": "Verbesserungsvorschlag",
    "feedback.category.bug": "Etwas funktioniert nicht",
    "feedback.category.performance": "Geschwindigkeit oder Stabilität",
    "feedback.category.content": "Inhalt",
    "feedback.category.account": "Konto",
    "feedback.category.billing": "Abrechnung",
    "feedback.category.other": "Sonstiges",
    "feedback.details.section": "Details",
    "feedback.details.placeholder": "Beschreibe, was du erwartet hast und was passiert ist",
    "feedback.characterCount": "Zeichen",
    "feedback.diagnostics.toggle": "Diagnosedaten einschließen",
    "feedback.diagnostics.description": "Enthält App-Version, Gerätemodell, Betriebssystem, Sprache und aktuelle Seite. Passwörter, Tokens, Einladungsgeheimnisse und Nachrichteninhalte werden nie erfasst.",
    "feedback.followUp.toggle": "Rückfragen erlauben",
    "feedback.followUp.email": "Kontakt-E-Mail (optional)",
    "feedback.submit": "Feedback senden",
    "feedback.result.submitted": "Danke. Dein Feedback wurde gesendet.",
    "feedback.result.queued": "Auf diesem Gerät gespeichert und wird automatisch gesendet, sobald das Netzwerk verfügbar ist.",
    "feedback.close": "Schließen",
    "feedback.settings.section": "Feedback & Datenschutz",
    "feedback.settings.open": "Feedback senden",
    "feedback.settings.quickEntry": "Zum Feedback schütteln",
    "feedback.settings.quickEntry.description": "Schüttle das Gerät, um Feedback schnell zu öffnen.",
    "feedback.settings.analytics": "Analyse & Verbesserungen",
    "feedback.settings.analytics.description": "Teile Erstanbieter-Nutzungs- und Diagnosedaten, um Artist zu verbessern.",
  },
  "es-419": {
    "feedback.title": "Comentarios",
    "feedback.introduction": "¿Tuviste algún problema de experiencia? Cuéntanos aquí. Si no hay red, el informe se guarda en este dispositivo y se envía automáticamente después.",
    "feedback.category.section": "¿Qué ocurrió?",
    "feedback.category.label": "Tipo",
    "feedback.category.experience": "Sugerencia de experiencia",
    "feedback.category.bug": "Algo no funciona",
    "feedback.category.performance": "Velocidad o estabilidad",
    "feedback.category.content": "Contenido",
    "feedback.category.account": "Cuenta",
    "feedback.category.billing": "Facturación",
    "feedback.category.other": "Otro",
    "feedback.details.section": "Detalles",
    "feedback.details.placeholder": "Describe qué esperabas y qué ocurrió",
    "feedback.characterCount": "Caracteres",
    "feedback.diagnostics.toggle": "Incluir diagnósticos",
    "feedback.diagnostics.description": "Incluye versión de la app, modelo del dispositivo, sistema, idioma y página actual. Nunca incluye contraseñas, tokens, secretos de invitación ni contenido de mensajes.",
    "feedback.followUp.toggle": "Permitir seguimiento",
    "feedback.followUp.email": "Correo de contacto (opcional)",
    "feedback.submit": "Enviar comentarios",
    "feedback.result.submitted": "Gracias. Tus comentarios se enviaron.",
    "feedback.result.queued": "Guardado en este dispositivo; se enviará automáticamente cuando haya red.",
    "feedback.close": "Cerrar",
    "feedback.settings.section": "Comentarios y privacidad",
    "feedback.settings.open": "Enviar comentarios",
    "feedback.settings.quickEntry": "Agitar para enviar comentarios",
    "feedback.settings.quickEntry.description": "Agita el dispositivo para abrir rápidamente los comentarios.",
    "feedback.settings.analytics": "Análisis y mejoras",
    "feedback.settings.analytics.description": "Comparte datos propios de uso y diagnóstico para mejorar Artist.",
  },
  "fr": {
    "feedback.title": "Commentaires",
    "feedback.introduction": "Avez-vous rencontré un problème d’expérience ? Dites-le-nous ici. Sans réseau, le rapport est enregistré sur cet appareil puis envoyé automatiquement.",
    "feedback.category.section": "Que s’est-il passé ?",
    "feedback.category.label": "Type",
    "feedback.category.experience": "Suggestion d’expérience",
    "feedback.category.bug": "Quelque chose ne fonctionne pas",
    "feedback.category.performance": "Vitesse ou stabilité",
    "feedback.category.content": "Contenu",
    "feedback.category.account": "Compte",
    "feedback.category.billing": "Facturation",
    "feedback.category.other": "Autre",
    "feedback.details.section": "Détails",
    "feedback.details.placeholder": "Décrivez ce que vous attendiez et ce qui s’est passé",
    "feedback.characterCount": "Caractères",
    "feedback.diagnostics.toggle": "Inclure les diagnostics",
    "feedback.diagnostics.description": "Inclut la version de l’app, le modèle de l’appareil, le système, la langue et la page actuelle. N’inclut jamais les mots de passe, jetons, secrets d’invitation ni le contenu des messages.",
    "feedback.followUp.toggle": "Autoriser un suivi",
    "feedback.followUp.email": "E-mail de contact (facultatif)",
    "feedback.submit": "Envoyer les commentaires",
    "feedback.result.submitted": "Merci. Vos commentaires ont été envoyés.",
    "feedback.result.queued": "Enregistré sur cet appareil et envoyé automatiquement dès que le réseau est disponible.",
    "feedback.close": "Fermer",
    "feedback.settings.section": "Commentaires et confidentialité",
    "feedback.settings.open": "Envoyer des commentaires",
    "feedback.settings.quickEntry": "Secouer pour commenter",
    "feedback.settings.quickEntry.description": "Secouez l’appareil pour ouvrir rapidement les commentaires.",
    "feedback.settings.analytics": "Analyse et améliorations",
    "feedback.settings.analytics.description": "Partagez les données d’utilisation et de diagnostic internes pour améliorer Artist.",
  },
  "it": {
    "feedback.title": "Feedback",
    "feedback.introduction": "Hai riscontrato un problema nell’esperienza? Segnalalo qui. Se la rete non è disponibile, la segnalazione viene salvata sul dispositivo e inviata automaticamente in seguito.",
    "feedback.category.section": "Che cosa è successo?",
    "feedback.category.label": "Tipo",
    "feedback.category.experience": "Suggerimento sull’esperienza",
    "feedback.category.bug": "Qualcosa non funziona",
    "feedback.category.performance": "Velocità o stabilità",
    "feedback.category.content": "Contenuto",
    "feedback.category.account": "Account",
    "feedback.category.billing": "Fatturazione",
    "feedback.category.other": "Altro",
    "feedback.details.section": "Dettagli",
    "feedback.details.placeholder": "Descrivi cosa ti aspettavi e cosa è successo",
    "feedback.characterCount": "Caratteri",
    "feedback.diagnostics.toggle": "Includi diagnostica",
    "feedback.diagnostics.description": "Include versione dell’app, modello del dispositivo, sistema, lingua e pagina corrente. Non include mai password, token, segreti di invito o contenuto dei messaggi.",
    "feedback.followUp.toggle": "Consenti ricontatto",
    "feedback.followUp.email": "E-mail di contatto (facoltativa)",
    "feedback.submit": "Invia feedback",
    "feedback.result.submitted": "Grazie. Il feedback è stato inviato.",
    "feedback.result.queued": "Salvato sul dispositivo; verrà inviato automaticamente quando la rete sarà disponibile.",
    "feedback.close": "Chiudi",
    "feedback.settings.section": "Feedback e privacy",
    "feedback.settings.open": "Invia feedback",
    "feedback.settings.quickEntry": "Scuoti per inviare feedback",
    "feedback.settings.quickEntry.description": "Scuoti il dispositivo per aprire rapidamente il feedback.",
    "feedback.settings.analytics": "Analisi e miglioramenti",
    "feedback.settings.analytics.description": "Condividi dati proprietari di utilizzo e diagnostica per migliorare Artist.",
  },
  "pt-BR": {
    "feedback.title": "Feedback",
    "feedback.introduction": "Teve algum problema de experiência? Conte para nós aqui. Se a rede estiver indisponível, o relato será salvo neste dispositivo e enviado automaticamente depois.",
    "feedback.category.section": "O que aconteceu?",
    "feedback.category.label": "Tipo",
    "feedback.category.experience": "Sugestão de experiência",
    "feedback.category.bug": "Algo não está funcionando",
    "feedback.category.performance": "Velocidade ou estabilidade",
    "feedback.category.content": "Conteúdo",
    "feedback.category.account": "Conta",
    "feedback.category.billing": "Cobrança",
    "feedback.category.other": "Outro",
    "feedback.details.section": "Detalhes",
    "feedback.details.placeholder": "Descreva o que você esperava e o que aconteceu",
    "feedback.characterCount": "Caracteres",
    "feedback.diagnostics.toggle": "Incluir diagnóstico",
    "feedback.diagnostics.description": "Inclui versão do app, modelo do dispositivo, sistema, idioma e página atual. Nunca inclui senhas, tokens, segredos de convite nem conteúdo de mensagens.",
    "feedback.followUp.toggle": "Permitir contato posterior",
    "feedback.followUp.email": "E-mail de contato (opcional)",
    "feedback.submit": "Enviar feedback",
    "feedback.result.submitted": "Obrigado. Seu feedback foi enviado.",
    "feedback.result.queued": "Salvo neste dispositivo e será enviado automaticamente quando a rede estiver disponível.",
    "feedback.close": "Fechar",
    "feedback.settings.section": "Feedback e privacidade",
    "feedback.settings.open": "Enviar feedback",
    "feedback.settings.quickEntry": "Agitar para dar feedback",
    "feedback.settings.quickEntry.description": "Agite o dispositivo para abrir o feedback rapidamente.",
    "feedback.settings.analytics": "Análises e melhorias",
    "feedback.settings.analytics.description": "Compartilhe dados próprios de uso e diagnóstico para melhorar o Artist.",
  },
  "ru": {
    "feedback.title": "Обратная связь",
    "feedback.introduction": "Возникла проблема при использовании? Расскажите нам здесь. Без сети сообщение сохранится на устройстве и отправится автоматически позже.",
    "feedback.category.section": "Что произошло?",
    "feedback.category.label": "Тип",
    "feedback.category.experience": "Предложение по удобству",
    "feedback.category.bug": "Что-то не работает",
    "feedback.category.performance": "Скорость или стабильность",
    "feedback.category.content": "Контент",
    "feedback.category.account": "Аккаунт",
    "feedback.category.billing": "Оплата",
    "feedback.category.other": "Другое",
    "feedback.details.section": "Подробности",
    "feedback.details.placeholder": "Опишите, чего вы ожидали и что произошло",
    "feedback.characterCount": "Символы",
    "feedback.diagnostics.toggle": "Добавить диагностику",
    "feedback.diagnostics.description": "Включает версию приложения, модель устройства, ОС, язык и текущую страницу. Никогда не включает пароли, токены, секреты приглашений или содержимое сообщений.",
    "feedback.followUp.toggle": "Разрешить обратную связь",
    "feedback.followUp.email": "Контактный e-mail (необязательно)",
    "feedback.submit": "Отправить отзыв",
    "feedback.result.submitted": "Спасибо. Отзыв отправлен.",
    "feedback.result.queued": "Сохранено на устройстве и будет отправлено автоматически при появлении сети.",
    "feedback.close": "Закрыть",
    "feedback.settings.section": "Отзывы и конфиденциальность",
    "feedback.settings.open": "Отправить отзыв",
    "feedback.settings.quickEntry": "Встряхнуть для отзыва",
    "feedback.settings.quickEntry.description": "Встряхните устройство, чтобы быстро открыть форму отзыва.",
    "feedback.settings.analytics": "Аналитика и улучшения",
    "feedback.settings.analytics.description": "Передавать собственные данные об использовании и диагностике для улучшения Artist.",
  },
  "ja": {
    "feedback.title": "フィードバック",
    "feedback.introduction": "使い心地の問題がありましたか？ここでお知らせください。ネットワークがない場合は端末に保存され、復旧後に自動送信されます。",
    "feedback.category.section": "何が起きましたか？",
    "feedback.category.label": "種類",
    "feedback.category.experience": "体験に関する提案",
    "feedback.category.bug": "機能が動作しない",
    "feedback.category.performance": "速度または安定性",
    "feedback.category.content": "コンテンツ",
    "feedback.category.account": "アカウント",
    "feedback.category.billing": "請求",
    "feedback.category.other": "その他",
    "feedback.details.section": "詳細",
    "feedback.details.placeholder": "期待していたことと実際に起きたことを説明してください",
    "feedback.characterCount": "文字数",
    "feedback.diagnostics.toggle": "診断情報を含める",
    "feedback.diagnostics.description": "アプリのバージョン、端末モデル、OS、言語、現在のページを含みます。パスワード、トークン、招待シークレット、メッセージ内容は含みません。",
    "feedback.followUp.toggle": "連絡を許可",
    "feedback.followUp.email": "連絡先メール（任意）",
    "feedback.submit": "フィードバックを送信",
    "feedback.result.submitted": "ありがとうございます。フィードバックを送信しました。",
    "feedback.result.queued": "端末に保存しました。ネットワーク復旧後に自動送信されます。",
    "feedback.close": "閉じる",
    "feedback.settings.section": "フィードバックとプライバシー",
    "feedback.settings.open": "フィードバックを送信",
    "feedback.settings.quickEntry": "振ってフィードバック",
    "feedback.settings.quickEntry.description": "端末を振るとフィードバック画面をすぐに開けます。",
    "feedback.settings.analytics": "分析と改善",
    "feedback.settings.analytics.description": "Artist の改善のため、ファーストパーティの利用状況と診断データを共有します。",
  },
  "ko": {
    "feedback.title": "피드백",
    "feedback.introduction": "사용 중 불편한 점이 있었나요? 여기에 알려 주세요. 네트워크가 없으면 기기에 저장되며 연결 후 자동으로 전송됩니다.",
    "feedback.category.section": "무슨 일이 있었나요?",
    "feedback.category.label": "유형",
    "feedback.category.experience": "사용 경험 제안",
    "feedback.category.bug": "기능이 작동하지 않음",
    "feedback.category.performance": "속도 또는 안정성",
    "feedback.category.content": "콘텐츠",
    "feedback.category.account": "계정",
    "feedback.category.billing": "결제",
    "feedback.category.other": "기타",
    "feedback.details.section": "세부 정보",
    "feedback.details.placeholder": "기대한 결과와 실제로 일어난 일을 설명해 주세요",
    "feedback.characterCount": "문자 수",
    "feedback.diagnostics.toggle": "진단 정보 포함",
    "feedback.diagnostics.description": "앱 버전, 기기 모델, OS, 언어 및 현재 페이지를 포함합니다. 비밀번호, 토큰, 초대 비밀값 또는 메시지 내용은 포함하지 않습니다.",
    "feedback.followUp.toggle": "후속 연락 허용",
    "feedback.followUp.email": "연락처 이메일(선택 사항)",
    "feedback.submit": "피드백 보내기",
    "feedback.result.submitted": "감사합니다. 피드백을 보냈습니다.",
    "feedback.result.queued": "기기에 저장했습니다. 네트워크가 연결되면 자동으로 전송됩니다.",
    "feedback.close": "닫기",
    "feedback.settings.section": "피드백 및 개인정보 보호",
    "feedback.settings.open": "피드백 보내기",
    "feedback.settings.quickEntry": "흔들어 피드백 열기",
    "feedback.settings.quickEntry.description": "기기를 흔들어 피드백을 빠르게 열 수 있습니다.",
    "feedback.settings.analytics": "분석 및 개선",
    "feedback.settings.analytics.description": "Artist 개선을 위해 자사 사용 및 진단 데이터를 공유합니다.",
  },
  "ar": {
    "feedback.title": "الملاحظات",
    "feedback.introduction": "هل واجهت مشكلة في التجربة؟ أخبرنا هنا. عند عدم توفر الشبكة يُحفظ البلاغ على هذا الجهاز ويُرسل تلقائيًا لاحقًا.",
    "feedback.category.section": "ماذا حدث؟",
    "feedback.category.label": "النوع",
    "feedback.category.experience": "اقتراح لتحسين التجربة",
    "feedback.category.bug": "شيء لا يعمل",
    "feedback.category.performance": "السرعة أو الاستقرار",
    "feedback.category.content": "المحتوى",
    "feedback.category.account": "الحساب",
    "feedback.category.billing": "الفوترة",
    "feedback.category.other": "أخرى",
    "feedback.details.section": "التفاصيل",
    "feedback.details.placeholder": "صِف ما كنت تتوقعه وما حدث فعليًا",
    "feedback.characterCount": "الأحرف",
    "feedback.diagnostics.toggle": "تضمين بيانات التشخيص",
    "feedback.diagnostics.description": "يتضمن إصدار التطبيق وطراز الجهاز والنظام واللغة والصفحة الحالية. ولا يتضمن أبدًا كلمات المرور أو الرموز أو أسرار الدعوات أو محتوى الرسائل.",
    "feedback.followUp.toggle": "السماح بالمتابعة",
    "feedback.followUp.email": "بريد التواصل (اختياري)",
    "feedback.submit": "إرسال الملاحظات",
    "feedback.result.submitted": "شكرًا. تم إرسال ملاحظاتك.",
    "feedback.result.queued": "تم الحفظ على هذا الجهاز وسيُرسل تلقائيًا عند توفر الشبكة.",
    "feedback.close": "إغلاق",
    "feedback.settings.section": "الملاحظات والخصوصية",
    "feedback.settings.open": "إرسال الملاحظات",
    "feedback.settings.quickEntry": "هز الجهاز لإرسال ملاحظات",
    "feedback.settings.quickEntry.description": "هز الجهاز لفتح الملاحظات بسرعة.",
    "feedback.settings.analytics": "التحليلات والتحسينات",
    "feedback.settings.analytics.description": "شارك بيانات الاستخدام والتشخيص التابعة لنا لتحسين Artist.",
  },
  "fa": {
    "feedback.title": "بازخورد",
    "feedback.introduction": "در تجربهٔ کاربری مشکلی داشتید؟ اینجا به ما بگویید. اگر شبکه در دسترس نباشد، گزارش روی دستگاه ذخیره و بعداً خودکار ارسال می‌شود.",
    "feedback.category.section": "چه اتفاقی افتاد؟",
    "feedback.category.label": "نوع",
    "feedback.category.experience": "پیشنهاد تجربهٔ کاربری",
    "feedback.category.bug": "چیزی کار نمی‌کند",
    "feedback.category.performance": "سرعت یا پایداری",
    "feedback.category.content": "محتوا",
    "feedback.category.account": "حساب",
    "feedback.category.billing": "پرداخت",
    "feedback.category.other": "سایر",
    "feedback.details.section": "جزئیات",
    "feedback.details.placeholder": "توضیح دهید چه انتظاری داشتید و چه اتفاقی افتاد",
    "feedback.characterCount": "نویسه‌ها",
    "feedback.diagnostics.toggle": "افزودن اطلاعات عیب‌یابی",
    "feedback.diagnostics.description": "شامل نسخهٔ برنامه، مدل دستگاه، سیستم‌عامل، زبان و صفحهٔ فعلی است. هرگز شامل گذرواژه، توکن، راز دعوت یا محتوای پیام نیست.",
    "feedback.followUp.toggle": "اجازهٔ پیگیری",
    "feedback.followUp.email": "ایمیل تماس (اختیاری)",
    "feedback.submit": "ارسال بازخورد",
    "feedback.result.submitted": "سپاس. بازخورد شما ارسال شد.",
    "feedback.result.queued": "روی این دستگاه ذخیره شد و با در دسترس شدن شبکه خودکار ارسال می‌شود.",
    "feedback.close": "بستن",
    "feedback.settings.section": "بازخورد و حریم خصوصی",
    "feedback.settings.open": "ارسال بازخورد",
    "feedback.settings.quickEntry": "تکان دادن برای بازخورد",
    "feedback.settings.quickEntry.description": "برای باز کردن سریع بازخورد، دستگاه را تکان دهید.",
    "feedback.settings.analytics": "تحلیل و بهبود",
    "feedback.settings.analytics.description": "داده‌های استفاده و عیب‌یابی مستقیم را برای بهبود Artist به اشتراک بگذارید.",
  },
  "ur": {
    "feedback.title": "رائے",
    "feedback.introduction": "کیا استعمال میں کوئی مسئلہ پیش آیا؟ ہمیں یہاں بتائیں۔ نیٹ ورک نہ ہو تو رپورٹ اس آلے پر محفوظ ہو کر بعد میں خودکار طور پر بھیج دی جائے گی۔",
    "feedback.category.section": "کیا ہوا؟",
    "feedback.category.label": "قسم",
    "feedback.category.experience": "تجربے کی تجویز",
    "feedback.category.bug": "کچھ کام نہیں کر رہا",
    "feedback.category.performance": "رفتار یا استحکام",
    "feedback.category.content": "مواد",
    "feedback.category.account": "اکاؤنٹ",
    "feedback.category.billing": "بلنگ",
    "feedback.category.other": "دیگر",
    "feedback.details.section": "تفصیلات",
    "feedback.details.placeholder": "بتائیں آپ کی توقع کیا تھی اور حقیقت میں کیا ہوا",
    "feedback.characterCount": "حروف",
    "feedback.diagnostics.toggle": "تشخیصی معلومات شامل کریں",
    "feedback.diagnostics.description": "اس میں ایپ ورژن، آلے کا ماڈل، نظام، زبان اور موجودہ صفحہ شامل ہیں۔ پاس ورڈ، ٹوکن، دعوتی راز یا پیغام کا مواد کبھی شامل نہیں ہوتا۔",
    "feedback.followUp.toggle": "بعد میں رابطے کی اجازت",
    "feedback.followUp.email": "رابطہ ای میل (اختیاری)",
    "feedback.submit": "رائے بھیجیں",
    "feedback.result.submitted": "شکریہ۔ آپ کی رائے بھیج دی گئی۔",
    "feedback.result.queued": "اس آلے پر محفوظ کر لیا گیا ہے اور نیٹ ورک دستیاب ہوتے ہی خودکار طور پر بھیج دیا جائے گا۔",
    "feedback.close": "بند کریں",
    "feedback.settings.section": "رائے اور رازداری",
    "feedback.settings.open": "رائے بھیجیں",
    "feedback.settings.quickEntry": "رائے کے لیے آلہ ہلائیں",
    "feedback.settings.quickEntry.description": "رائے جلد کھولنے کے لیے آلہ ہلائیں۔",
    "feedback.settings.analytics": "تجزیات اور بہتری",
    "feedback.settings.analytics.description": "Artist کو بہتر بنانے کے لیے ہماری استعمال اور تشخیصی معلومات شیئر کریں۔",
  },
  "hi": {
    "feedback.title": "फ़ीडबैक",
    "feedback.introduction": "क्या आपको अनुभव में कोई समस्या हुई? हमें यहाँ बताएँ। नेटवर्क न होने पर रिपोर्ट इस डिवाइस में सहेजी जाएगी और बाद में अपने आप भेजी जाएगी।",
    "feedback.category.section": "क्या हुआ?",
    "feedback.category.label": "प्रकार",
    "feedback.category.experience": "अनुभव सुझाव",
    "feedback.category.bug": "कुछ काम नहीं कर रहा",
    "feedback.category.performance": "गति या स्थिरता",
    "feedback.category.content": "सामग्री",
    "feedback.category.account": "खाता",
    "feedback.category.billing": "बिलिंग",
    "feedback.category.other": "अन्य",
    "feedback.details.section": "विवरण",
    "feedback.details.placeholder": "बताएँ कि आपकी अपेक्षा क्या थी और वास्तव में क्या हुआ",
    "feedback.characterCount": "अक्षर",
    "feedback.diagnostics.toggle": "डायग्नोस्टिक जानकारी शामिल करें",
    "feedback.diagnostics.description": "इसमें ऐप संस्करण, डिवाइस मॉडल, सिस्टम, भाषा और वर्तमान पेज शामिल हैं। पासवर्ड, टोकन, आमंत्रण रहस्य या संदेश सामग्री कभी शामिल नहीं होती।",
    "feedback.followUp.toggle": "बाद में संपर्क की अनुमति दें",
    "feedback.followUp.email": "संपर्क ईमेल (वैकल्पिक)",
    "feedback.submit": "फ़ीडबैक भेजें",
    "feedback.result.submitted": "धन्यवाद। आपका फ़ीडबैक भेज दिया गया है।",
    "feedback.result.queued": "इस डिवाइस पर सहेजा गया है और नेटवर्क मिलने पर अपने आप भेज दिया जाएगा।",
    "feedback.close": "बंद करें",
    "feedback.settings.section": "फ़ीडबैक और गोपनीयता",
    "feedback.settings.open": "फ़ीडबैक भेजें",
    "feedback.settings.quickEntry": "फ़ीडबैक के लिए डिवाइस हिलाएँ",
    "feedback.settings.quickEntry.description": "फ़ीडबैक जल्दी खोलने के लिए डिवाइस हिलाएँ।",
    "feedback.settings.analytics": "विश्लेषण और सुधार",
    "feedback.settings.analytics.description": "Artist को बेहतर बनाने के लिए प्रथम-पक्ष उपयोग और डायग्नोस्टिक डेटा साझा करें।",
  },
  "bn": {
    "feedback.title": "মতামত",
    "feedback.introduction": "ব্যবহারের অভিজ্ঞতায় কোনো সমস্যা হয়েছে? এখানে জানান। নেটওয়ার্ক না থাকলে প্রতিবেদনটি এই ডিভাইসে সংরক্ষিত হয়ে পরে স্বয়ংক্রিয়ভাবে পাঠানো হবে।",
    "feedback.category.section": "কী ঘটেছে?",
    "feedback.category.label": "ধরন",
    "feedback.category.experience": "অভিজ্ঞতা উন্নতির পরামর্শ",
    "feedback.category.bug": "কিছু কাজ করছে না",
    "feedback.category.performance": "গতি বা স্থিতিশীলতা",
    "feedback.category.content": "কনটেন্ট",
    "feedback.category.account": "অ্যাকাউন্ট",
    "feedback.category.billing": "বিলিং",
    "feedback.category.other": "অন্যান্য",
    "feedback.details.section": "বিস্তারিত",
    "feedback.details.placeholder": "আপনি কী আশা করেছিলেন এবং কী ঘটেছে তা লিখুন",
    "feedback.characterCount": "অক্ষর",
    "feedback.diagnostics.toggle": "ডায়াগনস্টিক তথ্য অন্তর্ভুক্ত করুন",
    "feedback.diagnostics.description": "এতে অ্যাপ সংস্করণ, ডিভাইস মডেল, সিস্টেম, ভাষা ও বর্তমান পৃষ্ঠা থাকে। পাসওয়ার্ড, টোকেন, আমন্ত্রণের গোপন তথ্য বা বার্তার বিষয়বস্তু কখনো থাকে না।",
    "feedback.followUp.toggle": "পরবর্তী যোগাযোগের অনুমতি দিন",
    "feedback.followUp.email": "যোগাযোগের ইমেইল (ঐচ্ছিক)",
    "feedback.submit": "মতামত পাঠান",
    "feedback.result.submitted": "ধন্যবাদ। আপনার মতামত পাঠানো হয়েছে।",
    "feedback.result.queued": "এই ডিভাইসে সংরক্ষিত হয়েছে এবং নেটওয়ার্ক পাওয়া গেলে স্বয়ংক্রিয়ভাবে পাঠানো হবে।",
    "feedback.close": "বন্ধ করুন",
    "feedback.settings.section": "মতামত ও গোপনীয়তা",
    "feedback.settings.open": "মতামত পাঠান",
    "feedback.settings.quickEntry": "মতামতের জন্য ডিভাইস ঝাঁকান",
    "feedback.settings.quickEntry.description": "দ্রুত মতামত খুলতে ডিভাইস ঝাঁকান।",
    "feedback.settings.analytics": "বিশ্লেষণ ও উন্নতি",
    "feedback.settings.analytics.description": "Artist উন্নত করতে নিজস্ব ব্যবহার ও ডায়াগনস্টিক তথ্য শেয়ার করুন।",
  },
  "mr": {
    "feedback.title": "अभिप्राय",
    "feedback.introduction": "वापराच्या अनुभवात अडचण आली का? आम्हाला येथे सांगा. नेटवर्क नसल्यास अहवाल या डिव्हाइसवर जतन होऊन नंतर आपोआप पाठवला जाईल.",
    "feedback.category.section": "काय झाले?",
    "feedback.category.label": "प्रकार",
    "feedback.category.experience": "अनुभव सुधारणा सूचना",
    "feedback.category.bug": "काहीतरी काम करत नाही",
    "feedback.category.performance": "वेग किंवा स्थिरता",
    "feedback.category.content": "मजकूर",
    "feedback.category.account": "खाते",
    "feedback.category.billing": "बिलिंग",
    "feedback.category.other": "इतर",
    "feedback.details.section": "तपशील",
    "feedback.details.placeholder": "तुमची अपेक्षा काय होती आणि काय झाले ते सांगा",
    "feedback.characterCount": "अक्षरे",
    "feedback.diagnostics.toggle": "निदान माहिती समाविष्ट करा",
    "feedback.diagnostics.description": "यात अॅप आवृत्ती, डिव्हाइस मॉडेल, प्रणाली, भाषा आणि सध्याचे पृष्ठ समाविष्ट असते. पासवर्ड, टोकन, आमंत्रण गुपिते किंवा संदेश मजकूर कधीही समाविष्ट होत नाही.",
    "feedback.followUp.toggle": "पुढील संपर्कास परवानगी",
    "feedback.followUp.email": "संपर्क ईमेल (ऐच्छिक)",
    "feedback.submit": "अभिप्राय पाठवा",
    "feedback.result.submitted": "धन्यवाद. तुमचा अभिप्राय पाठवला आहे.",
    "feedback.result.queued": "या डिव्हाइसवर जतन झाले आहे आणि नेटवर्क उपलब्ध झाल्यावर आपोआप पाठवले जाईल.",
    "feedback.close": "बंद करा",
    "feedback.settings.section": "अभिप्राय आणि गोपनीयता",
    "feedback.settings.open": "अभिप्राय पाठवा",
    "feedback.settings.quickEntry": "अभिप्रायासाठी डिव्हाइस हलवा",
    "feedback.settings.quickEntry.description": "अभिप्राय पटकन उघडण्यासाठी डिव्हाइस हलवा.",
    "feedback.settings.analytics": "विश्लेषण आणि सुधारणा",
    "feedback.settings.analytics.description": "Artist सुधारण्यासाठी प्रथम-पक्ष वापर आणि निदान डेटा शेअर करा.",
  },
  "gu": {
    "feedback.title": "પ્રતિસાદ",
    "feedback.introduction": "ઉપયોગ દરમિયાન કોઈ સમસ્યા આવી? અમને અહીં જણાવો. નેટવર્ક ન હોય તો અહેવાલ આ ઉપકરણમાં સાચવાઈ પછી આપમેળે મોકલાશે.",
    "feedback.category.section": "શું થયું?",
    "feedback.category.label": "પ્રકાર",
    "feedback.category.experience": "અનુભવ સુધારાનું સૂચન",
    "feedback.category.bug": "કંઈક કામ કરતું નથી",
    "feedback.category.performance": "ઝડપ અથવા સ્થિરતા",
    "feedback.category.content": "સામગ્રી",
    "feedback.category.account": "ખાતું",
    "feedback.category.billing": "બિલિંગ",
    "feedback.category.other": "અન્ય",
    "feedback.details.section": "વિગતો",
    "feedback.details.placeholder": "તમે શું અપેક્ષા રાખી હતી અને શું થયું તે લખો",
    "feedback.characterCount": "અક્ષરો",
    "feedback.diagnostics.toggle": "નિદાન માહિતી ઉમેરો",
    "feedback.diagnostics.description": "તેમાં એપ વર્ઝન, ઉપકરણ મોડેલ, સિસ્ટમ, ભાષા અને હાલનું પાનું સામેલ છે. પાસવર્ડ, ટોકન, આમંત્રણ રહસ્ય અથવા સંદેશાની સામગ્રી ક્યારેય સામેલ થતી નથી.",
    "feedback.followUp.toggle": "પછી સંપર્ક કરવાની મંજૂરી",
    "feedback.followUp.email": "સંપર્ક ઇમેઇલ (વૈકલ્પિક)",
    "feedback.submit": "પ્રતિસાદ મોકલો",
    "feedback.result.submitted": "આભાર. તમારો પ્રતિસાદ મોકલાયો છે.",
    "feedback.result.queued": "આ ઉપકરણમાં સાચવાયું છે અને નેટવર્ક મળતાં આપમેળે મોકલાશે.",
    "feedback.close": "બંધ કરો",
    "feedback.settings.section": "પ્રતિસાદ અને ગોપનીયતા",
    "feedback.settings.open": "પ્રતિસાદ મોકલો",
    "feedback.settings.quickEntry": "પ્રતિસાદ માટે ઉપકરણ હલાવો",
    "feedback.settings.quickEntry.description": "પ્રતિસાદ ઝડપથી ખોલવા ઉપકરણ હલાવો.",
    "feedback.settings.analytics": "વિશ્લેષણ અને સુધારાઓ",
    "feedback.settings.analytics.description": "Artist સુધારવા પ્રથમ-પક્ષ ઉપયોગ અને નિદાન ડેટા શેર કરો.",
  },
  "ta": {
    "feedback.title": "கருத்து",
    "feedback.introduction": "பயன்பாட்டு அனுபவத்தில் சிக்கல் ஏற்பட்டதா? இங்கே தெரிவிக்கவும். இணையம் இல்லையெனில் அறிக்கை சாதனத்தில் சேமிக்கப்பட்டு பின்னர் தானாக அனுப்பப்படும்.",
    "feedback.category.section": "என்ன நடந்தது?",
    "feedback.category.label": "வகை",
    "feedback.category.experience": "அனுபவ மேம்பாட்டு பரிந்துரை",
    "feedback.category.bug": "ஏதோ செயல்படவில்லை",
    "feedback.category.performance": "வேகம் அல்லது நிலைத்தன்மை",
    "feedback.category.content": "உள்ளடக்கம்",
    "feedback.category.account": "கணக்கு",
    "feedback.category.billing": "கட்டணம்",
    "feedback.category.other": "மற்றவை",
    "feedback.details.section": "விவரங்கள்",
    "feedback.details.placeholder": "நீங்கள் எதிர்பார்த்தது மற்றும் நடந்தது என்ன என்பதை விவரிக்கவும்",
    "feedback.characterCount": "எழுத்துகள்",
    "feedback.diagnostics.toggle": "கண்டறிதல் தகவலைச் சேர்க்கவும்",
    "feedback.diagnostics.description": "ஆப் பதிப்பு, சாதன மாதிரி, அமைப்பு, மொழி மற்றும் தற்போதைய பக்கம் இதில் அடங்கும். கடவுச்சொற்கள், டோக்கன்கள், அழைப்பு ரகசியங்கள் அல்லது செய்தி உள்ளடக்கம் ஒருபோதும் சேராது.",
    "feedback.followUp.toggle": "தொடர்பு கொள்ள அனுமதி",
    "feedback.followUp.email": "தொடர்பு மின்னஞ்சல் (விருப்பம்)",
    "feedback.submit": "கருத்தை அனுப்பவும்",
    "feedback.result.submitted": "நன்றி. உங்கள் கருத்து அனுப்பப்பட்டது.",
    "feedback.result.queued": "இந்த சாதனத்தில் சேமிக்கப்பட்டது; இணையம் கிடைக்கும்போது தானாக அனுப்பப்படும்.",
    "feedback.close": "மூடு",
    "feedback.settings.section": "கருத்து மற்றும் தனியுரிமை",
    "feedback.settings.open": "கருத்தை அனுப்பவும்",
    "feedback.settings.quickEntry": "கருத்துக்கு சாதனத்தை அசைக்கவும்",
    "feedback.settings.quickEntry.description": "கருத்தை விரைவாகத் திறக்க சாதனத்தை அசைக்கவும்.",
    "feedback.settings.analytics": "பகுப்பாய்வு மற்றும் மேம்பாடுகள்",
    "feedback.settings.analytics.description": "Artist-ஐ மேம்படுத்த முதல் தரப்பு பயன்பாடு மற்றும் கண்டறிதல் தரவைப் பகிரவும்.",
  },
  "te": {
    "feedback.title": "అభిప్రాయం",
    "feedback.introduction": "వినియోగ అనుభవంలో సమస్య ఎదురైందా? ఇక్కడ తెలియజేయండి. నెట్‌వర్క్ లేకపోతే నివేదిక ఈ పరికరంలో నిల్వై తర్వాత స్వయంచాలకంగా పంపబడుతుంది.",
    "feedback.category.section": "ఏం జరిగింది?",
    "feedback.category.label": "రకం",
    "feedback.category.experience": "అనుభవ మెరుగుదల సూచన",
    "feedback.category.bug": "ఏదో పనిచేయడం లేదు",
    "feedback.category.performance": "వేగం లేదా స్థిరత్వం",
    "feedback.category.content": "కంటెంట్",
    "feedback.category.account": "ఖాతా",
    "feedback.category.billing": "బిల్లింగ్",
    "feedback.category.other": "ఇతర",
    "feedback.details.section": "వివరాలు",
    "feedback.details.placeholder": "మీరు ఆశించినది మరియు జరిగినది వివరించండి",
    "feedback.characterCount": "అక్షరాలు",
    "feedback.diagnostics.toggle": "నిర్ధారణ సమాచారాన్ని చేర్చండి",
    "feedback.diagnostics.description": "యాప్ వెర్షన్, పరికర మోడల్, సిస్టమ్, భాష మరియు ప్రస్తుత పేజీ ఇందులో ఉంటాయి. పాస్‌వర్డ్‌లు, టోకెన్లు, ఆహ్వాన రహస్యాలు లేదా సందేశ కంటెంట్ ఎప్పుడూ ఉండవు.",
    "feedback.followUp.toggle": "తదుపరి సంప్రదింపుకు అనుమతి",
    "feedback.followUp.email": "సంప్రదింపు ఇమెయిల్ (ఐచ్ఛికం)",
    "feedback.submit": "అభిప్రాయం పంపండి",
    "feedback.result.submitted": "ధన్యవాదాలు. మీ అభిప్రాయం పంపబడింది.",
    "feedback.result.queued": "ఈ పరికరంలో నిల్వైంది; నెట్‌వర్క్ అందుబాటులోకి వచ్చినప్పుడు స్వయంచాలకంగా పంపబడుతుంది.",
    "feedback.close": "మూసివేయి",
    "feedback.settings.section": "అభిప్రాయం మరియు గోప్యత",
    "feedback.settings.open": "అభిప్రాయం పంపండి",
    "feedback.settings.quickEntry": "అభిప్రాయం కోసం పరికరాన్ని కదపండి",
    "feedback.settings.quickEntry.description": "అభిప్రాయాన్ని త్వరగా తెరవడానికి పరికరాన్ని కదపండి.",
    "feedback.settings.analytics": "విశ్లేషణలు మరియు మెరుగుదలలు",
    "feedback.settings.analytics.description": "Artist మెరుగుదలకు స్వంత వినియోగ మరియు నిర్ధారణ డేటాను పంచుకోండి.",
  },
  "th": {
    "feedback.title": "ความคิดเห็น",
    "feedback.introduction": "พบปัญหาในการใช้งานหรือไม่? แจ้งเราได้ที่นี่ หากไม่มีเครือข่าย รายงานจะถูกบันทึกในอุปกรณ์และส่งอัตโนมัติภายหลัง",
    "feedback.category.section": "เกิดอะไรขึ้น?",
    "feedback.category.label": "ประเภท",
    "feedback.category.experience": "ข้อเสนอแนะด้านประสบการณ์",
    "feedback.category.bug": "บางอย่างใช้งานไม่ได้",
    "feedback.category.performance": "ความเร็วหรือความเสถียร",
    "feedback.category.content": "เนื้อหา",
    "feedback.category.account": "บัญชี",
    "feedback.category.billing": "การเรียกเก็บเงิน",
    "feedback.category.other": "อื่น ๆ",
    "feedback.details.section": "รายละเอียด",
    "feedback.details.placeholder": "อธิบายสิ่งที่คุณคาดหวังและสิ่งที่เกิดขึ้น",
    "feedback.characterCount": "อักขระ",
    "feedback.diagnostics.toggle": "รวมข้อมูลวินิจฉัย",
    "feedback.diagnostics.description": "รวมเวอร์ชันแอป รุ่นอุปกรณ์ ระบบ ภาษา และหน้าปัจจุบัน โดยไม่รวมรหัสผ่าน โทเค็น ความลับของคำเชิญ หรือเนื้อหาข้อความ",
    "feedback.followUp.toggle": "อนุญาตให้ติดต่อกลับ",
    "feedback.followUp.email": "อีเมลติดต่อ (ไม่บังคับ)",
    "feedback.submit": "ส่งความคิดเห็น",
    "feedback.result.submitted": "ขอบคุณ ส่งความคิดเห็นแล้ว",
    "feedback.result.queued": "บันทึกไว้ในอุปกรณ์แล้ว และจะส่งอัตโนมัติเมื่อมีเครือข่าย",
    "feedback.close": "ปิด",
    "feedback.settings.section": "ความคิดเห็นและความเป็นส่วนตัว",
    "feedback.settings.open": "ส่งความคิดเห็น",
    "feedback.settings.quickEntry": "เขย่าเพื่อส่งความคิดเห็น",
    "feedback.settings.quickEntry.description": "เขย่าอุปกรณ์เพื่อเปิดความคิดเห็นอย่างรวดเร็ว",
    "feedback.settings.analytics": "การวิเคราะห์และการปรับปรุง",
    "feedback.settings.analytics.description": "แชร์ข้อมูลการใช้งานและการวินิจฉัยของเราเพื่อช่วยปรับปรุง Artist",
  },
  "tr": {
    "feedback.title": "Geri bildirim",
    "feedback.introduction": "Deneyimde bir sorunla karşılaştınız mı? Buradan bize bildirin. Ağ yoksa rapor bu cihazda saklanır ve daha sonra otomatik gönderilir.",
    "feedback.category.section": "Ne oldu?",
    "feedback.category.label": "Tür",
    "feedback.category.experience": "Deneyim önerisi",
    "feedback.category.bug": "Bir şey çalışmıyor",
    "feedback.category.performance": "Hız veya kararlılık",
    "feedback.category.content": "İçerik",
    "feedback.category.account": "Hesap",
    "feedback.category.billing": "Faturalandırma",
    "feedback.category.other": "Diğer",
    "feedback.details.section": "Ayrıntılar",
    "feedback.details.placeholder": "Ne beklediğinizi ve ne olduğunu açıklayın",
    "feedback.characterCount": "Karakter",
    "feedback.diagnostics.toggle": "Tanılama bilgilerini ekle",
    "feedback.diagnostics.description": "Uygulama sürümü, cihaz modeli, sistem, dil ve geçerli sayfayı içerir. Parolaları, belirteçleri, davet sırlarını veya mesaj içeriğini asla içermez.",
    "feedback.followUp.toggle": "Takibe izin ver",
    "feedback.followUp.email": "İletişim e-postası (isteğe bağlı)",
    "feedback.submit": "Geri bildirim gönder",
    "feedback.result.submitted": "Teşekkürler. Geri bildiriminiz gönderildi.",
    "feedback.result.queued": "Bu cihazda kaydedildi ve ağ kullanılabilir olduğunda otomatik gönderilecek.",
    "feedback.close": "Kapat",
    "feedback.settings.section": "Geri bildirim ve gizlilik",
    "feedback.settings.open": "Geri bildirim gönder",
    "feedback.settings.quickEntry": "Geri bildirim için salla",
    "feedback.settings.quickEntry.description": "Geri bildirimi hızla açmak için cihazı sallayın.",
    "feedback.settings.analytics": "Analiz ve iyileştirmeler",
    "feedback.settings.analytics.description": "Artist’i iyileştirmek için birinci taraf kullanım ve tanılama verilerini paylaşın.",
  },
  "vi": {
    "feedback.title": "Phản hồi",
    "feedback.introduction": "Bạn gặp vấn đề khi sử dụng? Hãy cho chúng tôi biết tại đây. Khi không có mạng, báo cáo được lưu trên thiết bị và tự động gửi sau.",
    "feedback.category.section": "Điều gì đã xảy ra?",
    "feedback.category.label": "Loại",
    "feedback.category.experience": "Đề xuất trải nghiệm",
    "feedback.category.bug": "Có chức năng không hoạt động",
    "feedback.category.performance": "Tốc độ hoặc độ ổn định",
    "feedback.category.content": "Nội dung",
    "feedback.category.account": "Tài khoản",
    "feedback.category.billing": "Thanh toán",
    "feedback.category.other": "Khác",
    "feedback.details.section": "Chi tiết",
    "feedback.details.placeholder": "Mô tả điều bạn mong đợi và điều đã xảy ra",
    "feedback.characterCount": "Ký tự",
    "feedback.diagnostics.toggle": "Kèm dữ liệu chẩn đoán",
    "feedback.diagnostics.description": "Bao gồm phiên bản ứng dụng, mẫu thiết bị, hệ điều hành, ngôn ngữ và trang hiện tại. Không bao giờ bao gồm mật khẩu, token, bí mật lời mời hoặc nội dung tin nhắn.",
    "feedback.followUp.toggle": "Cho phép liên hệ lại",
    "feedback.followUp.email": "Email liên hệ (không bắt buộc)",
    "feedback.submit": "Gửi phản hồi",
    "feedback.result.submitted": "Cảm ơn. Phản hồi của bạn đã được gửi.",
    "feedback.result.queued": "Đã lưu trên thiết bị và sẽ tự động gửi khi có mạng.",
    "feedback.close": "Đóng",
    "feedback.settings.section": "Phản hồi và quyền riêng tư",
    "feedback.settings.open": "Gửi phản hồi",
    "feedback.settings.quickEntry": "Lắc để phản hồi",
    "feedback.settings.quickEntry.description": "Lắc thiết bị để mở nhanh phần phản hồi.",
    "feedback.settings.analytics": "Phân tích và cải tiến",
    "feedback.settings.analytics.description": "Chia sẻ dữ liệu sử dụng và chẩn đoán của bên thứ nhất để cải thiện Artist.",
  },
  "id": {
    "feedback.title": "Masukan",
    "feedback.introduction": "Mengalami masalah saat menggunakan aplikasi? Beri tahu kami di sini. Jika jaringan tidak tersedia, laporan disimpan di perangkat dan dikirim otomatis nanti.",
    "feedback.category.section": "Apa yang terjadi?",
    "feedback.category.label": "Jenis",
    "feedback.category.experience": "Saran pengalaman",
    "feedback.category.bug": "Ada yang tidak berfungsi",
    "feedback.category.performance": "Kecepatan atau stabilitas",
    "feedback.category.content": "Konten",
    "feedback.category.account": "Akun",
    "feedback.category.billing": "Penagihan",
    "feedback.category.other": "Lainnya",
    "feedback.details.section": "Detail",
    "feedback.details.placeholder": "Jelaskan apa yang Anda harapkan dan apa yang terjadi",
    "feedback.characterCount": "Karakter",
    "feedback.diagnostics.toggle": "Sertakan diagnostik",
    "feedback.diagnostics.description": "Mencakup versi aplikasi, model perangkat, sistem, bahasa, dan halaman saat ini. Tidak pernah mencakup kata sandi, token, rahasia undangan, atau isi pesan.",
    "feedback.followUp.toggle": "Izinkan tindak lanjut",
    "feedback.followUp.email": "Email kontak (opsional)",
    "feedback.submit": "Kirim masukan",
    "feedback.result.submitted": "Terima kasih. Masukan Anda telah dikirim.",
    "feedback.result.queued": "Disimpan di perangkat ini dan akan dikirim otomatis saat jaringan tersedia.",
    "feedback.close": "Tutup",
    "feedback.settings.section": "Masukan & Privasi",
    "feedback.settings.open": "Kirim Masukan",
    "feedback.settings.quickEntry": "Goyangkan untuk memberi masukan",
    "feedback.settings.quickEntry.description": "Goyangkan perangkat untuk membuka masukan dengan cepat.",
    "feedback.settings.analytics": "Analitik & Peningkatan",
    "feedback.settings.analytics.description": "Bagikan data penggunaan dan diagnostik pihak pertama untuk meningkatkan Artist.",
  },
  "fil": {
    "feedback.title": "Feedback",
    "feedback.introduction": "May problema ba sa paggamit? Sabihin sa amin dito. Kapag walang network, mase-save ang ulat sa device at awtomatikong maipapadala sa ibang pagkakataon.",
    "feedback.category.section": "Ano ang nangyari?",
    "feedback.category.label": "Uri",
    "feedback.category.experience": "Mungkahi sa karanasan",
    "feedback.category.bug": "May hindi gumagana",
    "feedback.category.performance": "Bilis o katatagan",
    "feedback.category.content": "Content",
    "feedback.category.account": "Account",
    "feedback.category.billing": "Pagsingil",
    "feedback.category.other": "Iba pa",
    "feedback.details.section": "Mga detalye",
    "feedback.details.placeholder": "Ilarawan ang inaasahan mo at ang nangyari",
    "feedback.characterCount": "Mga character",
    "feedback.diagnostics.toggle": "Isama ang diagnostics",
    "feedback.diagnostics.description": "Kasama ang bersyon ng app, modelo ng device, system, wika at kasalukuyang page. Hindi kailanman kasama ang password, token, lihim ng imbitasyon o nilalaman ng mensahe.",
    "feedback.followUp.toggle": "Payagan ang follow-up",
    "feedback.followUp.email": "Contact email (opsyonal)",
    "feedback.submit": "Ipadala ang feedback",
    "feedback.result.submitted": "Salamat. Naipadala na ang feedback mo.",
    "feedback.result.queued": "Naka-save sa device at awtomatikong ipapadala kapag may network.",
    "feedback.close": "Isara",
    "feedback.settings.section": "Feedback at Privacy",
    "feedback.settings.open": "Magpadala ng Feedback",
    "feedback.settings.quickEntry": "I-shake para mag-feedback",
    "feedback.settings.quickEntry.description": "I-shake ang device para mabilis na buksan ang feedback.",
    "feedback.settings.analytics": "Analytics at Mga Pagpapahusay",
    "feedback.settings.analytics.description": "Ibahagi ang first-party usage at diagnostic data para mapahusay ang Artist.",
  },
  "sw": {
    "feedback.title": "Maoni",
    "feedback.introduction": "Umekumbana na tatizo la matumizi? Tuambie hapa. Mtandao usipopatikana, ripoti huhifadhiwa kwenye kifaa na kutumwa kiotomatiki baadaye.",
    "feedback.category.section": "Nini kilitokea?",
    "feedback.category.label": "Aina",
    "feedback.category.experience": "Pendekezo la matumizi",
    "feedback.category.bug": "Kuna kisichofanya kazi",
    "feedback.category.performance": "Kasi au uthabiti",
    "feedback.category.content": "Maudhui",
    "feedback.category.account": "Akaunti",
    "feedback.category.billing": "Malipo",
    "feedback.category.other": "Nyingine",
    "feedback.details.section": "Maelezo",
    "feedback.details.placeholder": "Eleza ulichotarajia na kilichotokea",
    "feedback.characterCount": "Herufi",
    "feedback.diagnostics.toggle": "Jumuisha uchunguzi",
    "feedback.diagnostics.description": "Inajumuisha toleo la programu, modeli ya kifaa, mfumo, lugha na ukurasa wa sasa. Haijumuishi kamwe nenosiri, tokeni, siri za mwaliko au maudhui ya ujumbe.",
    "feedback.followUp.toggle": "Ruhusu ufuatiliaji",
    "feedback.followUp.email": "Barua pepe ya mawasiliano (si lazima)",
    "feedback.submit": "Tuma maoni",
    "feedback.result.submitted": "Asante. Maoni yako yametumwa.",
    "feedback.result.queued": "Yamehifadhiwa kwenye kifaa na yatatumwa kiotomatiki mtandao ukipatikana.",
    "feedback.close": "Funga",
    "feedback.settings.section": "Maoni na Faragha",
    "feedback.settings.open": "Tuma Maoni",
    "feedback.settings.quickEntry": "Tikisa ili kutoa maoni",
    "feedback.settings.quickEntry.description": "Tikisa kifaa ili kufungua maoni haraka.",
    "feedback.settings.analytics": "Uchanganuzi na Maboresho",
    "feedback.settings.analytics.description": "Shiriki data ya matumizi na uchunguzi ya huduma hii ili kuboresha Artist.",
  },
  "ha": {
    "feedback.title": "Ra’ayi",
    "feedback.introduction": "Ka samu matsala wajen amfani? Faɗa mana a nan. Idan babu hanyar sadarwa, za a adana rahoton a na’urar sannan a aika ta atomatik daga baya.",
    "feedback.category.section": "Me ya faru?",
    "feedback.category.label": "Nau’i",
    "feedback.category.experience": "Shawarar ƙwarewa",
    "feedback.category.bug": "Wani abu baya aiki",
    "feedback.category.performance": "Sauri ko kwanciyar hankali",
    "feedback.category.content": "Abun ciki",
    "feedback.category.account": "Asusu",
    "feedback.category.billing": "Biyan kuɗi",
    "feedback.category.other": "Sauran",
    "feedback.details.section": "Cikakkun bayanai",
    "feedback.details.placeholder": "Bayyana abin da ka zata da abin da ya faru",
    "feedback.characterCount": "Haruffa",
    "feedback.diagnostics.toggle": "Haɗa bayanan bincike",
    "feedback.diagnostics.description": "Ya haɗa da sigar manhaja, samfurin na’ura, tsarin aiki, harshe da shafin yanzu. Ba ya haɗa kalmomin sirri, token, sirrin gayyata ko abun saƙo.",
    "feedback.followUp.toggle": "Ba da damar tuntuɓa",
    "feedback.followUp.email": "Imel na tuntuɓa (na zaɓi)",
    "feedback.submit": "Aika ra’ayi",
    "feedback.result.submitted": "Mun gode. An aika ra’ayinka.",
    "feedback.result.queued": "An adana a na’urar kuma za a aika ta atomatik idan hanyar sadarwa ta samu.",
    "feedback.close": "Rufe",
    "feedback.settings.section": "Ra’ayi da Sirri",
    "feedback.settings.open": "Aika Ra’ayi",
    "feedback.settings.quickEntry": "Girgiza don bayar da ra’ayi",
    "feedback.settings.quickEntry.description": "Girgiza na’urar don buɗe ra’ayi da sauri.",
    "feedback.settings.analytics": "Nazari da Ingantawa",
    "feedback.settings.analytics.description": "Raba bayanan amfani da bincike na kai tsaye don inganta Artist.",
  },
  "am": {
    "feedback.title": "ግብረመልስ",
    "feedback.introduction": "የአጠቃቀም ችግር አጋጥሞዎታል? እዚህ ይንገሩን። ኔትወርክ ከሌለ ሪፖርቱ በመሣሪያው ላይ ተቀምጦ በኋላ በራስ-ሰር ይላካል።",
    "feedback.category.section": "ምን ተፈጠረ?",
    "feedback.category.label": "ዓይነት",
    "feedback.category.experience": "የተሞክሮ ማሻሻያ ሀሳብ",
    "feedback.category.bug": "አንድ ነገር አይሰራም",
    "feedback.category.performance": "ፍጥነት ወይም መረጋጋት",
    "feedback.category.content": "ይዘት",
    "feedback.category.account": "መለያ",
    "feedback.category.billing": "ክፍያ",
    "feedback.category.other": "ሌላ",
    "feedback.details.section": "ዝርዝሮች",
    "feedback.details.placeholder": "የጠበቁትን እና የተፈጠረውን ይግለጹ",
    "feedback.characterCount": "ቁምፊዎች",
    "feedback.diagnostics.toggle": "የምርመራ መረጃ አካትት",
    "feedback.diagnostics.description": "የመተግበሪያ ስሪት፣ የመሣሪያ ሞዴል፣ ስርዓት፣ ቋንቋ እና የአሁኑን ገጽ ያካትታል። የይለፍ ቃል፣ token፣ የግብዣ ሚስጥር ወይም የመልዕክት ይዘት አያካትትም።",
    "feedback.followUp.toggle": "ቀጣይ ግንኙነት ፍቀድ",
    "feedback.followUp.email": "የመገናኛ ኢሜይል (አማራጭ)",
    "feedback.submit": "ግብረመልስ ላክ",
    "feedback.result.submitted": "እናመሰግናለን። ግብረመልስዎ ተልኳል።",
    "feedback.result.queued": "በመሣሪያው ላይ ተቀምጧል፤ ኔትወርክ ሲገኝ በራስ-ሰር ይላካል።",
    "feedback.close": "ዝጋ",
    "feedback.settings.section": "ግብረመልስ እና ግላዊነት",
    "feedback.settings.open": "ግብረመልስ ላክ",
    "feedback.settings.quickEntry": "ለግብረመልስ መሣሪያውን አንቀጥቅጥ",
    "feedback.settings.quickEntry.description": "ግብረመልስን ፈጥነው ለመክፈት መሣሪያውን ያንቀጥቅጡ።",
    "feedback.settings.analytics": "ትንታኔ እና ማሻሻያ",
    "feedback.settings.analytics.description": "Artistን ለማሻሻል የአጠቃቀም እና የምርመራ መረጃ ያጋሩ።",
  },
};

const localeAliases: Record<string, FeedbackLocale> = {
  "es": "es-419",
  "pt": "pt-BR",
  "zh-cn": "zh-Hans",
  "zh-sg": "zh-Hans",
  "zh-tw": "zh-Hant",
  "zh-hk": "zh-Hant",
  "zh-mo": "zh-Hant",
};

export function feedbackCopyFor(language: string): FeedbackCopy {
  const normalized = language.trim().toLowerCase();
  const exact = Object.keys(feedbackCopy).find((key) => key.toLowerCase() === normalized) as FeedbackLocale | undefined;
  const base = normalized.split("-")[0] ?? "";
  const candidate = exact ?? localeAliases[normalized] ?? localeAliases[base];
  if (candidate !== undefined) return feedbackCopy[candidate];
  const baseLocale = Object.keys(feedbackCopy).find((key) => key.toLowerCase() === base) as FeedbackLocale | undefined;
  return baseLocale === undefined ? feedbackCopy.en : feedbackCopy[baseLocale];
}
